import { render, staticRenderFns } from "./InvoicesDataTable.template.vue?vue&type=template&id=8e22839a&scoped=true&"
var script = {}
import style0 from "./InvoicesDataTable.template.vue?vue&type=style&index=0&id=8e22839a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e22839a",
  null
  
)

export default component.exports